import { defineComponent as _defineComponent } from 'vue'
import { Button } from '@travelata-libs/ui-kit';
import { pluralize, useViewport } from '@travelata-libs/utils'
import { ref, computed, watch } from 'vue';
import { Rating, Progress } from '@travelata-libs/ui-shared';
import getHotelReviews from '../api/getHotelReviews';
import { type HotelReview, type InfoRating, type HotelReviewsResult } from '../api/types';
import { MAX_SIZE_REVIEWS } from '../config';
import HotelReviewCard from './HotelReviewCard.vue';

interface HotelReviewsProps {
    hotelId: number;
    initialHotelReview: HotelReviewsResult['result'] | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HotelReviews',
  props: {
    hotelId: null,
    initialHotelReview: null
  },
  setup(__props: any) {

const props = __props as {
    hotelId: number;
    initialHotelReview: HotelReviewsResult['result'] | null;
};



const reviews = ref<HotelReview[]>([]);
const reviewsCount = computed(() => props.initialHotelReview?.count || 0);
const rate = computed(() => props.initialHotelReview?.rate || 0);
const infoRatings = computed<InfoRating[]>(() => props.initialHotelReview?.infoRatings || []);
const reviewsTotal = computed(() => props.initialHotelReview?.total || 0);
const page = ref(1);

const { isMobile } = useViewport();

const filteredInfoRatings = computed(() => infoRatings.value.filter((infoRating) => !!infoRating.rate));

const paginationReviews = computed(() => {
    return reviews.value.filter((review, index) => {
        return index < page.value * MAX_SIZE_REVIEWS;
    } );
});

const buttonText = computed(() => {
    const currentCount = page.value * MAX_SIZE_REVIEWS;

    const nextCount = reviews.value.slice(currentCount, currentCount + MAX_SIZE_REVIEWS).length;

    if(nextCount === 0) return '';

    return `Показать еще ${pluralize(['отзыв', 'отзыва', 'отзывов'], nextCount)}`;
});

const showMoreReviews = async () => {
    page.value++;
    if(reviews.value.length !== reviewsTotal.value)  {
        const res = await getHotelReviews({ limit: MAX_SIZE_REVIEWS * 2, hotelId: props.hotelId, page: page.value });
        reviews.value.push(...res.reviews); 
    }  
};

watch(() => props.initialHotelReview, (value) => {
    reviews.value = value?.reviews || [];
}, { immediate: true });

return { __sfc: true,props, reviews, reviewsCount, rate, infoRatings, reviewsTotal, page, isMobile, filteredInfoRatings, paginationReviews, buttonText, showMoreReviews, Button, Rating, Progress, HotelReviewCard }
}

})